// extracted by mini-css-extract-plugin
export var wrapper = "copy_color_message-module--wrapper--9f199";